export const LOGIN_MODEL ={
    email: '',
    password: '',
    code: null,
    toRegister: function (data) {
        return {
            email:data?.email,
            password:data?.password,
            code:data?.otp
        }
    },
}

export const BACK_TO_UI_LANG = {
    EN: "en",
    ES: "sp",
    FR: "fr",
};

export const UI_TO_BACK_LANG = {
    en: "EN",
    sp: "ES",
    fr: "FR",
};
